"use strict";

var _regeneratorRuntime = require("/opt/buildhome/repo/node_modules/@babel/runtime/regenerator/index.js");

var _classCallCheck = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FortmaticConnector = void 0;

var abstract_connector_1 = require("@web3-react/abstract-connector");

var schemas_1 = require("@dcl/schemas");

var configuration_1 = require("../configuration");

var FortmaticConnector = /*#__PURE__*/function (_abstract_connector_) {
  _inherits(FortmaticConnector, _abstract_connector_);

  var _super = _createSuper(FortmaticConnector);

  function FortmaticConnector(chainId) {
    var _this;

    _classCallCheck(this, FortmaticConnector);

    var fortmaticConfiguration = configuration_1.getConfiguration()[schemas_1.ProviderType.FORTMATIC];
    var supportedChainIds = Object.keys(fortmaticConfiguration.apiKeys).map(function (key) {
      return Number(key);
    });

    if (!supportedChainIds.includes(chainId)) {
      throw new Error("Invariant error: Unsupported chainId ".concat(chainId));
    }

    _this = _super.call(this, {
      supportedChainIds: supportedChainIds
    });
    _this.apiKey = fortmaticConfiguration.apiKeys[chainId];
    _this.chainId = chainId;
    _this.rpcUrl = fortmaticConfiguration.urls[chainId];
    return _this;
  }

  _createClass(FortmaticConnector, [{
    key: "activate",
    value: function activate() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$Promise$resolv, Fortmatic, account;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.fortmatic) {
                  _context.next = 6;
                  break;
                }

                _context.next = 3;
                return Promise.resolve().then(function () {
                  return __importStar(require('fortmatic'));
                });

              case 3:
                _yield$Promise$resolv = _context.sent;
                Fortmatic = _yield$Promise$resolv.default;
                this.fortmatic = new Fortmatic(this.apiKey, {
                  rpcUrl: this.rpcUrl,
                  chainId: this.chainId
                });

              case 6:
                _context.next = 8;
                return this.fortmatic.getProvider().enable().then(function (accounts) {
                  return accounts[0];
                });

              case 8:
                account = _context.sent;
                return _context.abrupt("return", {
                  provider: this.fortmatic.getProvider(),
                  chainId: this.chainId,
                  account: account
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getApiKey",
    value: function getApiKey() {
      return this.apiKey;
    }
  }, {
    key: "getProvider",
    value: function getProvider() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.fortmatic.getProvider());

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "getChainId",
    value: function getChainId() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.chainId);

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "getAccount",
    value: function getAccount() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.fortmatic.getProvider().send('eth_accounts').then(function (accounts) {
                  return accounts[0];
                }));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    } // tslint:disable-next-line

  }, {
    key: "deactivate",
    value: function deactivate() {}
  }, {
    key: "close",
    value: function close() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.fortmatic.user.logout();

              case 2:
                this.emitDeactivate();

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }]);

  return FortmaticConnector;
}(abstract_connector_1.AbstractConnector);

exports.FortmaticConnector = FortmaticConnector;